<ng-container *ngIf="game$ | async">
  <router-outlet></router-outlet>
</ng-container>
